import { observable, action, computed } from 'mobx';
import { makeObservable } from 'mobx';
import { ParameterState } from '/@/app/views/FreeMeasurementsView/ParameterState';


class FreeMeasurementsViewState {
    api=null;
    activeSection = null;

    user_id = null;  // set 1st time
    sections = [];  // dynamically loaded 1st time

    allParameters = null;
    visibleParameters = null; // null if not loaded, list if loaded; can be empty;

    recentNewParameter = null;  // to scroll to when added.

    constructor(api) {
	this.api=api;
        makeObservable(this, {
            user_id: observable,
            sections: observable,
            activeSection: observable,
            allParameters: observable,
            visibleParameters: observable,
            recentNewParameter: observable,
            //
            firstLoad: action,
            setSections: action,
            loadDefaultSection: action,
            loadSection: action,
            refresh: action,
            openSection: action,  // opens loaded section
            //
            activeSectionState: computed,
            //
            _addNewParameter: action,
            _removeParameter: action,
            _updateSections: action,
        });
    }

    get activeSectionState() {
        if (this.activeSection === null) {
            return null;
        }
        const section = this.sections.find(s => s.slug === this.activeSection);
        return section ? section : null;
    }

    firstLoad(user_id) {
        if (user_id === this.user_id) {
            return;
        }
        this.user_id = user_id;

        this.api.request(`cabinet/free/${user_id}/sections/`)
            .then(data => {
                this.setSections(data);
            });
    }

    setSections(data) {
        data.sort((a, b) => a.order - b.order);
        this.sections.replace(data);
    }

    loadDefaultSection() {
        if (this.sections.length === 0) {
            return;
        }
        this.loadSection(this.sections[0].slug);
    }

    loadSection(slug) {
        if (this.sections.length === 0) {
            return;
        }
        let section = this.sections.find(s => s.slug === slug);
        if (!section) {
            section = this.sections[0];
            slug = section.slug;
        }
        if (this.activeSection === section) {
            return;
        }
        this.allParameters = null;
        this.visibleParameters = null;
        this.api.request(`cabinet/free/${this.user_id}/parameters/history/sections/${section.id}/`)
            .then(data => {
                this.openSection(slug, data);
            });
    }

    refresh() {
        this.loadSection(this.activeSection);
    }

    openSection(slug, data) {
        this.activeSection = slug;
        this.allParameters = (
            data.map(item => new ParameterState(item))
        ).sort((a, b) => a.name.localeCompare(b.name));

        // this.visibleParameters = (
        //     data
        //         .map(item => new ParameterState(item))
        //         .filter(p =>
        //             p.hasData
        //             || p.dictionary === 'user-defined'
        //         )
        // )
        this.visibleParameters = this.allParameters;
    }


    _addNewParameter(parameter) {
        this.visibleParameters.push(parameter);
        this.visibleParameters = this.visibleParameters.sort((a, b) => a.name.localeCompare(b.name));
        // ensure scroll to the new parameter
        this.recentNewParameter = parameter;
    }

    _removeParameter(parameter) {
        this.visibleParameters.remove(parameter);
    }

    _updateSections(parameter) {
        const inThisSection = parameter.sections.find(s => s.slug === this.activeSection);
        if (inThisSection) {
            // Generally, we can't add to this section from the
            // same section, so do nothing.
        } else {
            this._removeParameter(parameter);
        }
    }
}

export const freeMeasurementsViewState = new FreeMeasurementsViewState();
export function injectApi(api)
{
	freeMeasurementsViewState.api=api;
}
